/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Anti_Freeze_Alarm_SetpointInputs */



/**
* | output |
* | --- |
* | "Anti-freeze alarm setpoint" |
*
* @param {Anti_Freeze_Alarm_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const anti_freeze_alarm_setpoint = /** @type {((inputs?: Anti_Freeze_Alarm_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Anti_Freeze_Alarm_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Anti-freeze alarm setpoint")
	return /** @type {LocalizedString} */ ("Consigne alarme antigel")
});